export const IconCommentFilled: {
  name: 'icon_comment_filled-c47ada097639'
} = {
  name: 'icon_comment_filled-c47ada097639'
}
